// removed by extract-text-webpack-plugin
module.exports = {"pieChartBox":"xs-LucLOQvRvykQT2azN9","dot":"_3XHFsleNvixPpRKQF4wQn6","percentageDescribe":"lNOX7DUw3FNdSTsNKBor2","bullets":"qXnFljNXCLK6RHx107Cpz","choreTitle":"_2d-MPPN1ZRmokpQzkqcrcL","pieWrap":"_27PAqKMHIzhKUeCs4dmxuK","noneYet":"F8tFlrryrD_D-n5at2toB","emptyChart":"_1l54xK1yCCvg7ym6D1eKRe","choreIcon":"_3fxdP94R6nYX9os2LqzZTi"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/ChorePieChart.css
// module id = 396
// module chunks = 0